document.addEventListener('DOMContentLoaded', function () {
    try {
        logoSlider();
        accordion();
        mediaSlider();
        productCardSlider();
        imageSlider();
        perfectProductAdd();
        paintFreeSliders();
        thumbnailSlider();
        upsellBuy();
        allProductsGroupScroll();
        mobileMenuLink();
        reviewSlider();
        centerImageChange();
        stickyProduct();
        packChange();
    } catch (error) {
        console.log(error)
    }
})

function perfectProductsSlider ( ) {

    let swiper = null;

    if(window.innerWidth < 750) { 
        swiper = new Swiper('.complementary-slide__inner', {
            slidesPerView : 1.2,
            spaceBetween : 10,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        })
    }
}

function logoSlider() {
    const logoSliders = document.querySelectorAll('.logo-slider__container');

    logoSliders.forEach(logoSlider => {

        const id = logoSlider.id;

        const quotes = logoSlider.querySelector('.logo-slider__quote--wrapper')

        const swiper = new Swiper(`#${id} .logo-slider__inner`, {
            slidesPerView : 'auto',
            spaceBetween : 0,
            loop : true,
            centeredSlides : true,
            loopAdditionalSlides : 30,    
            slideToClickedSlide: true,
            breakpoints: {
                990 : {
                    spaceBetween : 0,
                    loop : false,
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        })
    
        swiper.on('slideChange', function () {
            const activeSlide = swiper.slides[swiper.activeIndex];

            quotes.querySelector('.logo-item__quote.active')?.classList.remove('active');

            quotes.querySelector(`[data-quote-id="${activeSlide.dataset.sliderId}"]`)?.classList.add('active');
        });
    
        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            swiper.params.autoplay.delay = 5000;
            swiper.update()
        }

        swiper.on('reachEnd', () => {
            setTimeout(() => {
              swiper.slideTo(0);
            }, 2500);
        });
    })
}

function accordion() {
    document.querySelectorAll('.faqs-group__inner').forEach(group => {
        group.querySelectorAll('.faqs-group__item').forEach(accordion => {
            accordion.querySelector('.accordion-heading').addEventListener('click', function () {
                let body = accordion.querySelector('.accordion-body');

                accordion.classList.toggle('active');

                if (accordion.classList.contains('active')) {
                    body.style.maxHeight = body.scrollHeight + 'px';
                } else {
                    body.style.maxHeight = 0;
                }

            })
        })
    })
}

function mediaSlider () {
    let sliderComponents = document.querySelectorAll('.media-slider__container');

    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .media-slider__inner`, {
            slidesPerView: 1.5,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
            // const video = swiper.slides[Math.ceil(swiper.slides.length / 2 - 1)];

            swiper.slides.forEach(ele => {
                console.log(ele)
                ele.querySelector('video').play()
            })
        }

    })
}

function imageSlider () {
    let sliderComponents = document.querySelectorAll('.image-slider__container');

    
    sliderComponents.forEach(comp => {

        let sliderId = comp.id;

        const swiper = new Swiper(`#${sliderId} .image-slider__inner`, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop : false,  
            slideToClickedSlide: true,
            centeredSlides : true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                990 : {
                    slidesPerView: 3,
                    spaceBetween : 10,
                    pagination: false
                }
            }
        })

        if (swiper.slides.length > 0) {
            swiper?.slideTo(Math.ceil(swiper.slides.length / 2 - 1))
        }
    })
}

function productCardSlider () {
    let cards = document.querySelectorAll('.collection-product__card');

    cards.forEach(card => {
        let id = card.id;

        if(id) {
            new Swiper(`#${id} .product-card__media-slider`, {
                slidesPerView : 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            })
        }
    })
}

function paintFreeSliders() {
   let slides = document.querySelectorAll('.paint-free__container');

    slides.forEach(slide => {
        const id = slide.id;

        const medias = document.querySelector('.paint-free__media')
        const descriptions = document.querySelector('.paint-free__description-count')
        
        const swiper = new Swiper(`#${id} .paint-free__description`, {
            slidesPerView : 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });

        swiper.on('slideChange', function () {
            const currentIndex = swiper.activeIndex;

            descriptions.querySelector('.active')?.classList.remove('active');
            descriptions.querySelector(`[data-desc-index="${currentIndex + 1}"]`)?.classList.add('active');

            medias.querySelector('.active')?.classList.remove('active');
            medias.querySelector(`[data-point-index="${currentIndex + 1}"]`)?.classList.add('active');
        });

        medias.querySelectorAll('.media-point__position')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-point-index') - 1)
            })
        })

        descriptions.querySelectorAll('.description-count__number')?.forEach(media => {
            media.addEventListener('click' , function (e) {
                swiper.slideTo(media.getAttribute('data-desc-index') - 1)
            })
        })
    });
}

function perfectProductAdd() {
    const buy_buttons = document.querySelectorAll('.perfect-product-buy_button');
    buy_buttons.forEach(buy_button => {
        buy_button.addEventListener('click', function (e) {
            
            const product_id = buy_button.closest('.item__info').querySelector('#variant_id').value;
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            const data = {
                'id' : product_id,
                'quantity' : 1,
                "sections" : cart.getSectionsToRender().map((section) => section.id),
                "sections_url" : window.location.pathname
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then (res => {
                return res.json()
            }).then (resJson => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                setTimeout(() => {
                    cart.renderContents(resJson);
                }, 100);
            })
        })
    })

    document.querySelectorAll('.item__info-variants select').forEach(select => {

        const item = select.closest('.perfect-product__item');

        const json = JSON.parse(item.querySelector('[data-upsell-json]').textContent);

        const price = item.querySelector('.item__info-price');
        const discount = parseFloat(price.dataset.discountPercent);

        select.addEventListener('change', function () {
            const id = select.value;

            const variant = json.variants.find(v => v.id == id);

            if (discount) {
                price.innerHTML = `<div class="price">${getMoney((variant.price / 100) * discount)}</div><div class="compare">${getMoney(variant.price / 100)}</div>`
            } else {
                price.innerHTML = `<div class="price">${getMoney(variant.price / 100)}</div>`
            }
        })
    })
}

function getMoney(amount) {
    return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active,
    }).format(amount);
}

function thumbnailSlider() {
    const thumbnailWrapper = document.querySelector('.thumbnail-slider');

    if (thumbnailWrapper) {
        let swiper = new Swiper('.thumbnail-slider', {
            slidesPerView : 4.5,
            spaceBetween : 10,
            breakpoints: {
                990 : {
                    slidesPerView: 5.5,
                }
            }
        })
    }
}

function upsellBuy() { 
    const upsellProducts = document.querySelectorAll('.upsell-product--item');

    if (!customElements.get('upsell-cart-item')) {
        customElements.define('upsell-cart-item', 
            class upsellCartItem extends HTMLElement {
                constructor (){
                    super()

                    const buyButton = this.querySelector('.product--buy');
            
                    buyButton.addEventListener('click', function (e) {
                        const cart = document.querySelector('cart-drawer');
                        const data = {
                            'id' : buyButton.dataset.productId,
                            'quantity' : 1,
                            "sections" : cart.getSectionsToRender().map((section) => section.id),
                            "sections_url" : window.location.pathname
                        };
            
                        fetch('/cart/add.js', {
                            method : "POST",
                            headers : {
                                'Content-Type': 'application/json'
                            },
                            body : JSON.stringify(data)
                        }).then(res => {
                            return res.json();
                        }).then(resJson => {
                            cart.getSectionsToRender().forEach((section) => {
                            const sectionElement = section.selector
                                ? document.querySelector(section.selector)
                                : document.getElementById(section.id);
                        
                            if (!sectionElement) return;
                                sectionElement.innerHTML = cart.getSectionInnerHTML(resJson.sections[section.id], section.selector);
                            });

                            cart.querySelector('#CartDrawer-Overlay').addEventListener('click', cart.close.bind(cart));

                        })
                    })
                }
            }
        )
    }
}

function allProductsGroupScroll () {
    const labels = document.querySelectorAll('.products_label--item');

    labels.forEach(label => {
        label.addEventListener('click', function (e) {
            let wrapper = document.querySelector(`[data-block-group-id="${label.id}"]`);
            smoothScroll( wrapper.offsetTop , 500);
        })
    })
}

function smoothScroll(target, duration) {
    const start = window.scrollY;
    const distance = target - start;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Make sure progress does not exceed 1
        const ease = easeInOutQuad(progress); // You could use any easing function here
        window.scrollTo(0, start + (distance * ease));

        if (timeElapsed < duration) {
            requestAnimationFrame(animation); // Keep animating
        }
    }

    requestAnimationFrame(animation);
}

function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

function mobileMenuLink() {
    const menuItems = document.querySelectorAll('.menu-drawer-accordion-menu--item');

    menuItems.forEach(item => {
        item.querySelector('.accordion-menu__toggle')?.addEventListener('click', function(e) {
            e.preventDefault();

            if (e.target.classList.contains('.arrow-down') || e.target.closest('.arrow-down')) {
                item.classList.toggle('open')
                return;
            }

            if(e.target.getAttribute('href') != null) {
                window.location.href = e.target.getAttribute('href');
            }
        })
    })
}

function reviewSlider() {
    const reviewSliders = document.querySelectorAll('.reviews-slider__inner');

    reviewSliders.forEach(slider => {
        const sliderId = slider.id;

        var thumbs = new Swiper(`#${sliderId} .reviews-thumbnail__slider`, {
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        
        var slider = new Swiper(`#${sliderId} .reviews-main__slider`, {
            slidesPerView: 1,
            spaceBetween : 30,
            centeredSlides: true,
            loop: true,
            loopedSlides: 6,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: thumbs
            },
            breakpoints: {
                990 : {
                    spaceBetween : 15,
                }
            }
        });
    })
}

function centerImageChange () {
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        
        const mainImage = centerImage.querySelector('.center-image__media')
        
        centerImage.querySelectorAll('.center-image__card').forEach(card => {
            card.addEventListener('click', function(e) {
                const cardId = this.dataset.cardId;
                centerImage.querySelector('.center-image__card.active')?.classList.remove('active');

                card.classList.add('active');

                mainImage.querySelector(`.main-image.active`)?.classList.remove('active');
                mainImage.querySelector(`[data-card-id="${cardId}"]`)?.classList.add('active');
            })
        })

    })
}

function stickyProduct() {
    const stickyProducts = document.querySelectorAll('.sticky-product__container');
    const mainProduct = document.querySelector('.product');

    stickyProducts.forEach(stickyProduct => {

        if (stickyProduct) {
            stickyProduct.querySelector('.sticky-atc').addEventListener('click', function (e) {
                mainProduct.querySelector('.product-form__submit').click();
            })
        }

        window.addEventListener('scroll', function (e) {
            if(stickyProduct && mainProduct) {
                if (window.scrollY > mainProduct.scrollHeight) {
                    stickyProduct.classList.remove('hide');
                } else {
                    stickyProduct.classList.add('hide');
                }
            }
        })
    })
}

function packChange() {
    const packWrapper = document.querySelector('.product-form__pack-selector');
    const stickyWrappers = document.querySelectorAll('.sticky-product__container');
    

    packWrapper.querySelectorAll('input').forEach(input => {
        input.addEventListener('click', function (e) {

            const pack = input.nextElementSibling;

            const pro_min_price = document.querySelectorAll('.price-item--sale')
            const pro_max_price = document.querySelectorAll('.price-item--regular')
            const pro_badge = document.querySelectorAll('.price__badge-sale')

            const pack_min_price = pack.querySelector('.pack--min-price')
            const pack_max_price = pack.querySelector('.pack--max-price')
            
            if (pack_min_price && pro_min_price) {
                pro_min_price.forEach(el => {
                    el.innerHTML = pack_min_price.innerHTML
                })
            }

            if (pro_max_price && pack_max_price) {
                pro_max_price.forEach(el => {
                    el.innerHTML = pack_max_price.innerHTML
                })
            }
            /*
            if (pro_badge) {

                const percent = (parseFloat(pack_max_price.innerText.replace(/[^0-9.-]+/g,"")) - parseFloat(pack_min_price.innerText.replace(/[^0-9.-]+/g,""))) * 100 / parseFloat(pack_max_price.innerText.replace(/[^0-9.-]+/g,""));
                
                pro_badge.forEach(el => {
                    el.innerHTML = Math.round(percent) + " % off";
                })
            }
            */
            stickyWrappers.forEach(wrapper => {
                wrapper.querySelector('.product-pack').innerHTML = input.dataset.packName;

                wrapper.querySelectorAll('.price').forEach(ele => {
                    ele.innerHTML = pack_min_price.innerHTML
                })

                wrapper.querySelectorAll('.compare_price').forEach(ele => {
                    ele.innerHTML = pack_max_price.innerHTML
                })
            })
            
            const paymentElement = document.querySelector('shopify-payment-terms');

            if (paymentElement && paymentElement.shadowRoot) {
                const payment = paymentElement.shadowRoot;

                if (pack_min_price) {
                    payment.querySelector('#shopify-installments-content span').innerHTML = "$" + (parseFloat(pack_min_price.innerText.replace(/[^0-9.-]+/g,"")) / 4).toFixed(2);
                }
            }

            packWrapper.querySelector('.product-from__pack-label').innerHTML = input.dataset.packName;
        })
    })

    // packWrapper.querySelectorAll('input').forEach((input, index) => {
    //     if (index == 1) {
    //         setTimeout(() => {
    //             input.click()
    //         }, 500);
    //     }
    // })

    // console.log('aa')
}

window.addEventListener('DOMContentLoaded', function () {
    
    const centerImages = document.querySelectorAll('.center-image__container');

    centerImages.forEach(centerImage => {
        let cards = centerImage.querySelectorAll('.center-image__card');
        let currentIndex = 0;
        const totalHighlights = cards.length;
        let autoCycle;

        function showHighlight(index) {
            cards.forEach((highlight, i) => {
                if (index == i) {
                    highlight.click()
                }
            });
        }

        function nextHighlight() {
            currentIndex = (currentIndex + 1) % totalHighlights;
            showHighlight(currentIndex);
        }

        function startAutoCycle() {
            autoCycle = setInterval(() => {
                if (currentIndex < totalHighlights - 1) {
                    nextHighlight();
                } else {
                    showHighlight(0)
                    clearInterval(autoCycle);
                }
            }, 5000);
        }

        startAutoCycle()
    })

    const interval = setInterval(() => {
        const reviews = document.querySelectorAll('#judgeme_product_reviews'); // review class from Judge.me
        if (reviews.length > 0) {
            jdgmReviews();

            const declaimer = document.createElement('div');
            declaimer.classList.add('jdgm-gallery-disclaimer')
            declaimer.innerHTML = "Images and videos are for representation purposes only";

            setTimeout(function( ){
              if(document.querySelector('.jdgm-gallery-wrapper')) {
                  document.querySelector('.jdgm-gallery-wrapper').append(declaimer)
              }
            }, 500)
          
            const jdgm_header = document.querySelector('.jdgm-rev-widg__header');

            jdgm_header.querySelector('.jdgm-rev-widg__summary').append(jdgm_header.querySelector('.jdgm-rev-widg__title'))

            clearInterval(interval);
        }
    }, 300); 
})


function jdgmReviews () {
    const jdgm_revs = document.querySelectorAll('.jdgm-rev');

    jdgm_revs.forEach(jdgm_rev => {
        const jdgm_rev_header = jdgm_rev.querySelector('.jdgm-rev__header');
        const jdgm_rev__content = jdgm_rev.querySelector('.jdgm-rev__content');

        if (jdgm_rev_header.querySelector('.jdgm-rev__author-wrapper')) {
            jdgm_rev__content.append(jdgm_rev_header.querySelector('.jdgm-rev__author-wrapper'));
        }
    })

    setTimeout(jdgmReviews, 500);
}

/* Price badge */
(function () {
  const q = (s, r=document) => r.querySelector(s);

  const parsePrice = (t) => {
    let s = String(t || "")
      .replace(/[\u00A0\u2000-\u200B\u202F\u205F\u3000]/g, "")
      .replace(/[^\d.,-]/g, "")
      .replace(/^[^0-9-]+/, "")
      .replace(/^[.,]+/, "");
    const d = s.lastIndexOf(".");
    const c = s.lastIndexOf(",");
    if (c > -1 && d > -1) {
      s = (c > d) ? s.replace(/\./g, "").replace(",", ".") : s.replace(/,/g, "");
    } else if (c > -1) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/,/g, "");
    }
    const n = parseFloat(s);
    return Number.isFinite(n) ? Math.abs(n) : NaN;
  };

  const getWrapper = () => q(".product-form__packs--wrapper");
  const getSelectedInput = (wrap) => q('input[type="radio"]:checked', wrap);
  const getSelectedLabel = (wrap) => {
    const input = getSelectedInput(wrap);
    return input ? (wrap.querySelector(`label[for="${CSS.escape(input.id)}"]`) || input.nextElementSibling || null) : null;
  };
  const findBadge = (wrap) => {
    const container = wrap.closest(".product__info-container") || document;
    return container.querySelector(".product__price .badge.price__badge-sale");
  };

  const computePctFromLabel = (label) => {
    const minEl = q(".pack--min-price", label);
    const maxEl = q(".pack--max-price", label);
    if (!minEl || !maxEl) return null;
    const sale = parsePrice(minEl.textContent);
    const regular = parsePrice(maxEl.textContent);
    if (!(sale > 0) || !(regular > 0)) return null;
    const pct = Math.round(-((regular - sale) / regular) * 100);
    return Math.max(-100, Math.min(0, pct));
  };

  const applyFromSelected = (wrap) => {
    const label = getSelectedLabel(wrap);
    const badge = findBadge(wrap);
    if (!label || !badge) return;
    const pct = computePctFromLabel(label);
    if (pct === null) return;
    badge.textContent = `${pct}% off`;
  };

  const wrap = getWrapper();
  if (!wrap) return;

  const schedule = () => {
    requestAnimationFrame(() => applyFromSelected(wrap));
    setTimeout(() => applyFromSelected(wrap), 120);
    setTimeout(() => applyFromSelected(wrap), 300);
  };

  schedule();
  wrap.addEventListener("click", (e) => {
    if (e.target && (e.target.matches('input[type="radio"]') || e.target.closest(".product-form__pack"))) schedule();
  });
  wrap.addEventListener("change", (e) => {
    if (e.target && e.target.matches('input[type="radio"]')) schedule();
  });
})();